// Stub for FontAwesome Pro icons when not available
module.exports = {};
